import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { AssignDTBPackageToGroupsInput } from '../../_types/dtb';

export default function useManageDistributableDTBPackage() {
  const assignToGroups = async (
    orgId: string,
    dtbPackageId: string,
    data: AssignDTBPackageToGroupsInput,
    callback?: (result: any) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}/assign-to-groups`;
    await fetcher({
      url,
      method: 'post',
      body: data,
    })
      .then((result) => {
        if (callback) callback(result);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return { assignToGroups };
}

export const getDistributableOrganizations = async (
  orgId: string,
  dtbPackageId: string,
  callback?: (result: any) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}/distributable-changes`;
  await fetcher({
    url,
    method: 'get',
  })
    .then((result) => {
      if (callback) callback(result);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const distributePackage = async (
  orgId: string,
  dtbPackageId: string,
  organizations: { id: string }[],
  callback?: (result: any) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}/distributable-changes`;
  await fetcher({
    url,
    method: 'post',
    body: { organizations },
  })
    .then((result) => {
      if (callback) callback(result);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};
